
import { FETCH_PAYEMENT_METHODS_FAILURE, FETCH_PAYEMENT_METHODS_REMOVE, FETCH_PAYEMENT_METHODS_REQUEST, FETCH_PAYEMENT_METHODS_SUCCESS } from "../types/index";


const initialState = {
  data: [],
  loading: false,
  error: null,
};

const payementMethodsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case FETCH_PAYEMENT_METHODS_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_PAYEMENT_METHODS_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: null };
    case FETCH_PAYEMENT_METHODS_FAILURE:
      return { ...state, loading: false, error: action.error, data: [] };
    case FETCH_PAYEMENT_METHODS_REMOVE:
      return { ...state, loading: false, data: [], error: null };

    default:
      return state;
  }
};

export default payementMethodsReducer;
